import TruncateLines from '@components/TruncateLines'

import {
  EventItemInner,
  EventItemMessage,
  EventItemMessageWrapper,
  EventItemName,
  EventItemNameWrapper,
  EventItemRoot,
} from './index.styles'

interface EventProps {
  className?: string
  bannerUrl?: string
  href?: string
  name: string
  errorMessage?: string
  /** shown only if there is no error message */
  overlay?: React.ReactNode
}

const EventItem = ({ className, bannerUrl, href, name, errorMessage, overlay }: EventProps) => {
  return (
    <EventItemRoot className={className} $bannerUrl={bannerUrl} href={href} data-testid="event-item">
      <EventItemInner>
        <EventItemNameWrapper>
          <EventItemName data-testid="event-item-name">{!bannerUrl && name}</EventItemName>
        </EventItemNameWrapper>
      </EventItemInner>
      {errorMessage ? (
        <EventItemMessageWrapper>
          <EventItemMessage>
            <TruncateLines lines={6}>{errorMessage}</TruncateLines>
          </EventItemMessage>
        </EventItemMessageWrapper>
      ) : (
        overlay
      )}
    </EventItemRoot>
  )
}

export default EventItem
